import onlineOrderProductRepository from '../../../services/modules/order-product/online.order-product.repository';
import { ValidateOrderProductsOutput } from '../../../services/modules/order-product/order-product.types';
import OfflineOrderRulesValidator from '../domain/offlineOrder/rules/OfflineOrderRules.validator';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';
import ValidateOrderProductsUtils from './utils/validateOrderProducts.utils';

const onlineOrderProductRepositoryOfflineAdapters = (): ReturnType<
  typeof onlineOrderProductRepository
> => {
  return {
    validateOrderProducts: async (params) => {
      const order = await offlineOrdersRepository.getByIdOrThrow(params.orderId);

      const validator = new OfflineOrderRulesValidator();
      const errors = await validator.validateOrderProducts(order, params.userRole);

      const { orderProductsWithErrors, errorsWithQuantities } =
        ValidateOrderProductsUtils.formatOrderProductsErrors(errors);

      return createApiSauceResponse<ValidateOrderProductsOutput, ValidateOrderProductsOutput>({
        ok: true,
        data: {
          orderProductsWithErrors,
          errorsWithQuantities,
        },
      });
    },
  };
};

export default onlineOrderProductRepositoryOfflineAdapters;
